<template>
  <div>
    <div class="page" :key="index" v-for="(item, index) in arr">
      <div class="sticker design-5">
        <div class="top-section">
          <div class="left-column">
            <div class="rewards-logo">
              <img src="/img/icons/msr_logo.png" alt="MSR Logo" width="171" height="72" />
              <!-- <div class="logo-line-1">
                <span class="logo-my">My</span>
                <span class="logo-spencers">spencers</span>
              </div>
              <div class="logo-rewards">Rewa<span class="rupee-symbol-1">₹</span>ds</div> -->
            </div>
            <div v-if="item.showDiscountPrice" class="member-price-label">MEMBER<br />PRICE</div>
            <div v-if="item.showDiscountPrice" class="member-price-value">
              <span v-if="shouldShowRupee(item.memberPrice)" class="rupee-symbol-2">₹</span>{{ formatValue(item.memberPrice) }}
            </div>
          </div>
          <div class="right-column">
            <div v-if="item.showDiscountPrice" class="non-member-price-label">NON<br />MEMBER<br />PRICE</div>
            <div v-if="item.showDiscountPrice" class="non-member-price-value">
              <span v-if="shouldShowRupee(item.nonMemberPrice)" class="rupee-symbol-2">₹</span>{{ formatValue(item.nonMemberPrice) }}
            </div>
          </div>
        </div>
        <div class="middle-section">
          <div v-if="item.showProductName" class="product-name">{{ item.productName }}</div>
          <div v-if="item.showMrp" class="mrp-text">
            MRP
            <span v-if="shouldShowRupee(item.mrp)" class="rupee-symbol-small">₹</span>{{ formatValue(item.mrp) }}
          </div>
        </div>
        <div class="bottom-section">
          <div class="savings-message"
            ><span class="plus-symbol">+</span>SAVE UPTO 6% EXTRA MONTHLY | ₹600/MONTH WITH
            <span class="bottom-msr-logo">
              <img src="/img/icons/msr_logo.png" alt="MSR Logo" width="161" height="50" />
            </span>
          </div>
        </div>
      </div>
      <div class="validTo">(ValidTo:{{ item.validTo }})</div>
      <div class="footer-date"> (PPD:{{ currentDate() }}) </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoTemplateA4Msr',
  props: {
    data: Array
  },
  data() {
    return {
      arr: []
    };
  },
  watch: {
    data(newValue) {
      if (newValue !== null && newValue !== undefined) {
        this.arr = newValue.map(item => {
          const productName = item.articleDescription || '';
          return {
            productName,
            mrp: item.mrp,
            memberPrice: item.memberPrice,
            nonMemberPrice: item.offerPrice,
            savingsPercent: 6,
            showProductName: true,
            showMrp: true,
            showDiscountPrice: true,
            validTo: item.validTo
          };
        });
      }
    }
  },
  methods: {
    toNumber(value, defaultValue = 0) {
      const num = Number(value);
      return isNaN(num) ? defaultValue : num;
    },
    formatValue(value) {
      if (value === null || value === undefined) {
        return '';
      }
      return String(value);
    },
    shouldShowRupee(value) {
      if (value === null || value === undefined) {
        return false;
      }
      const str = String(value).trim();
      if (!str) {
        return false;
      }
      // If value already has a rupee or percentage symbol, don't prepend ₹
      if (str.includes('₹') || str.includes('%')) {
        return false;
      }
      // Only show rupee symbol for numeric values (prices), not labels like "Offer"
      const numeric = !Number.isNaN(Number(str.replace(/,/g, '')));
      return numeric;
    },
    currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
      return date;
    }
  }
};
</script>
